import FlipperClient from '@xo-union/sdk-flipper';

const flipperClient = new FlipperClient({
  apiKey: process.env.REACT_APP_FLIPPER_API_KEY,
  env: process.env.REACT_APP_APP_ENV === 'production' ? 'production' : 'qa',
});

export default flipperClient;
